import InclusionExclusionForm from "../../InclusionExclusionForm/InclusionExclusionForm";
import HistoryTable from "../../Components/Email/historyTable/historyTable";
import { CardContent } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import {
  Card,
  Col,
  Row,
  Modal,
  Button,
  Form,
  Table,
  Nav,
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from "react-bootstrap";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import InfoBar from "../../Components/InfoBar/InfoBar";
import { v4 as uuidv4 } from "uuid";
import "./InclusionExclusion.css";
import CommonLoader from "../../Components/Commonloader/commonloader";
import "../.././global.css";
import { CommonPathWay } from "../../Components/CommonPathWay.js";
import { commonAxios, formDataAxios } from "../ExperianPage/CommonAxios";
import { showAlertToast } from "../../Components/ToastComponent/AlertMessage.js";
import MatchFieldsModal from "./MatchFieldsModal.js";
import { useRootStore } from "../ExperianPage/store/rootContext";
const generateUniqueId = (isAdd) => {
  return uuidv4();
};
const InclusionExclusion = ({ expanded, prospectcall }) => {
  const rootStore = useRootStore();
  const { matchAppendStore } = rootStore;
  const fileInputRef = useRef(null);
  const [uploadFileDetails, setUploadFileDetails] = useState({
    exclusionName: "",
    fileName: "",
    type: "company",
    field: "",
    csvData: [],
    headers: [],
  });
  const [fileUploadSuccessPopup, setFileUploadSuccessPopup] = useState(false);
  const [triggerCommonLoader, setTriggerCommonLoader] = useState(false);
  const [formStatusNegativeAlert, setFormStatusNegativeAlert] = useState(false);
  const [wrongFormattedCSValert, setWrongFormattedCSValert] = useState(false);
  const [fileErrorMessage, setFileErrorMessage] = useState("");
  const [tableData, setTableData] = useState([]);
  const fieldOptions = [
    { label: "Select an option", value: "" },
    { label: "Phone", value: "phone" },
    { label: "Email", value: "email" },
    { label: "Domain", value: "domain" },
    { label: "LinkedIn URL", value: "linkedinURL" },
  ];
  const typeOptions = [
    { label: "Select an Option", value: "" },
    { label: "Company", value: "company" },
    { label: "People", value: "people" },
  ];
  const [entriesToShow, setEntriesToShow] = useState(10);
  const [selectedValues, setSelectedValues] = useState({});
  const [search, setSearch] = useState("");
  const [totalpage, settotalpage] = useState(0);
  const [options, setOptions] = useState([]);
  const [pollingTrigger, setPollingTrigger] = useState(0);
  const intervalRef = useRef(null);
  const handleEntriesChange = (value) => {
    setEntriesToShow(value);
    setCurrentPage(0);
  };

  const [currentPage, setCurrentPage] = useState(0);
  const handleresetForm = () => {
    setUploadFileDetails({
      exclusionName: "",
      fileName: "",
      type: "",
      field: "",
      csvData: [],
      headers: [],
    });
    setSelectedValues({});
    setOptions([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  useEffect(() => {
    matchAppendStore.processFile = (file) => {
      handleFileChange({ target: { files: [file] } });
    };
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getInclusionExclusionData(search);
    }, 3000);
    return () => clearTimeout(delayDebounce);
  }, [search]);

  const returnHeader = (data) => {
    if (!data || typeof data !== "object") return [];
    return Object.keys(data);
  };
  const uploadFile = async (file) => {
    console.log(file, "Got in data for file upload")
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await CommonPathWay(
        "/validation/bulkFileUploader",
        "POST",
        {},
        formData
      );
      // const response = {
      //   "insertId": "68ba9ae78a7b2b144080fe9a",
      //   "limitedData": [
      //     {
      //       "companyName": "Straumann UK",
      //       "sector": "Healthcare",
      //       "website": "straumann.com",
      //       "companyType": "Privately Held",
      //       "location": "3 Pegasus Pl",
      //       "linkedinURL": "linkedin.com/company/straumann",
      //       "youtubeURL": "",
      //       "companySize": "50 to 99",
      //       "peopleCount": "64"
      //     }
      //   ],
      //   "fileName": "matchandappend.csv"
      // }
      const headers = returnHeader(response?.data?.limitedData[0] ?? {});
      console.log(headers, "Got in data for headers")
      setUploadFileDetails((prev) => ({
        ...prev,
        headers,
        fileName: response?.data?.fileName ?? "",
        insertId: response?.data?.insertId ?? "",
        csvData: response?.data?.limitedData ?? []
      }));
      showAlertToast({
        type: "success",
        title: "Upload Complete",
        message: "File uploaded to server successfully.",
      });

      return response;
    } catch (err) {
      showAlertToast({
        type: "error",
        title: "Upload Failed",
        message: err.message,
      });
    }
  };
  const handleFileChange = (event, type) => {
    const file = event.target.files[0];
    uploadFile(file);
    // if (file.size > 10485760) {
    //   showAlertToast({
    //     type: "info",
    //     title: "Import Data ",
    //     message: "File size must be below 10MB",
    //   });
    //   return;
    // }
    // if (file) {
    //   showAlertToast({
    //     type: "success",
    //     title: "Success",
    //     message: "File Uploaded Successfully.",
    //   });
    //   matchAppendStore.setModalStep(parseInt(0));
    //   setUploadFileDetails((prev) => ({
    //     ...prev,
    //     fileName: file?.name,
    //   }));
    //   const reader = new FileReader();
    //   if (reader.length > 50000) {
    //     showAlertToast({
    //       type: "info",
    //       title: "Import Data ",
    //       message: "File length must be below 50K",
    //     });
    //     return;
    //   }
    //   reader.onload = async (e) => {
    //     const content = e.target.result;
    //     const rows = content
    //       .split("\n")
    //       .map((row) => {
    //         const cells = row
    //           .split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
    //           .map((cell) => {
    //             let cleaned = cell.trim();
    //             if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
    //               cleaned = cleaned.substring(1, cleaned.length - 1);
    //             }
    //             return cleaned.replace(/\r/g, "");
    //           })
    //           .filter(
    //             (cell) => cell !== "" && cell !== null && cell !== undefined
    //           );
    //         return cells.length > 0 ? cells : null;
    //       })
    //       .filter((row) => row !== null && row.length > 0);
    //     if (rows.length > 50001) {
    //       setUploadFileDetails((prev) => ({
    //         ...prev,
    //         fileName: "",
    //       }));
    //       fileInputRef.current.value = "";
    //       return;
    //     }
    //     const headers = rows[0] || [];
    //     const csvData = rows.slice(1).map((row) => {
    //       let rowObj = {};
    //       headers.forEach((header, index) => {
    //         rowObj[header] = row[index] !== undefined ? row[index] : "";
    //       });
    //       return rowObj;
    //     });
    //     console.log(headers, "Got in data for headers fileupload")
    //     setUploadFileDetails((prev) => ({
    //       ...prev,
    //       headers,
    //       csvData,
    //     }));
    //   };
    //   reader.readAsText(file);
    // }
  };
  useEffect(() => {
    if (formStatusNegativeAlert) {
      showAlertToast({
        type: "error",
        title: "Something went wrong",
        message: "Please fill at least 2 fields and upload proper file",
      });
      setFormStatusNegativeAlert(false);
    }
  }, [formStatusNegativeAlert]);
  const handleInClusionExclusionSubMission = async () => {
    setTriggerCommonLoader(true);
    const timestamp = new Date().toISOString();
    const filteredSelectedValues = Object.fromEntries(
      Object.entries(selectedValues).filter(([key, value]) => value !== "")
    );
    try {
      if (!uploadFileDetails?.exclusionName?.trim()) {
        setTriggerCommonLoader(false);
        matchAppendStore.showMatchModal = false;
        showAlertToast({
          type: "warning",
          title: "Validation Error",
          message: "Please enter a valid name before uploading.",
        });
        return;
      }
      const response = await commonAxios(
        "/saveInclusionExclusion",
        "POST",
        {},
        {
          field: filteredSelectedValues,
          name: uploadFileDetails?.exclusionName,
          insertId: uploadFileDetails?.insertId,
          data: uploadFileDetails?.csvData ?? [],
          fileId: uuidv4()
        }
      );
      if (response?.statusCode === 200) {
        showAlertToast({
          type: "success",
          title: "Success",
          message: "File Uploaded Successfully.",
        });
        setUploadFileDetails({
          exclusionName: "",
          fileName: "",
          type: "",
          field: "",
          csvData: [],
          headers: [],
        });
        matchAppendStore.showMatchModal = false;
        setTriggerCommonLoader(false);
        getInclusionExclusionData();
        setPollingTrigger(prev => prev + 1);
        handleresetForm();
      } else {
        showAlertToast({
          type: "warning",
          title: "Note",
          message: "Unable to upload file .",
        });
      }
    } catch (e) {
      showAlertToast({
        type: "warning",
        title: "Note",
        message: "Unable to upload file .",
      });
      setTriggerCommonLoader(false);
    }
  };
  const getInclusionExclusionData = async (searchTerm) => {
    setTriggerCommonLoader(true);
    try {
      const response = await commonAxios(
        `/getInclusionExclusion`,
        "GET",
        {
          search: searchTerm,
          offset: currentPage * entriesToShow,
          limit: entriesToShow,
        },
        {}
      );
      setTriggerCommonLoader(false);
      setTableData(response?.data?.list ?? []);
      settotalpage(response?.data?.totalCount)
    } catch (e) { }
  };
  const inclusionExclusionRowDelete = async (tableId) => {
    try {
      const respone = await commonAxios(
        `/deleteSavedSearchAndInclusionExclusion`,
        "POST",
        {},
        {
          tableId: tableId,
          type: "inclusionExclusion",
        }
      );
      getInclusionExclusionData();
    } catch (e) { }
  };




  const searchRef = useRef(search);
  const currentPageRef = useRef(currentPage);
  const entriesToShowRef = useRef(entriesToShow);

  useEffect(() => {
    searchRef.current = search;
    currentPageRef.current = currentPage;
    entriesToShowRef.current = entriesToShow;
  }, [search, currentPage, entriesToShow]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await commonAxios(
          `/getInclusionExclusion`,
          "GET",
          {
            search: searchRef.current,
            offset: currentPageRef.current * entriesToShowRef.current,
            limit: entriesToShowRef.current,
          },
          {}
        );

        const list = response?.data?.list ?? [];
        setTableData(list);
        settotalpage(response?.data?.totalCount);

        const hasProgress = list.some((item) => item.status === "progress");

        if (hasProgress && !intervalRef.current) {
          intervalRef.current = setInterval(fetchData, 20000);
        }

        if (!hasProgress && intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      } catch (error) {
        console.error("Polling error:", error);
      }
    };

    fetchData();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [pollingTrigger]); // re-trigger when a new upload or user action happens



  useEffect(() => {
    let intervalId;
    const getInclusionExclusionData = async () => {
      try {
        const response = await commonAxios(
          `/getInclusionExclusion`,
          "GET",
          {
            search: search,
            offset: currentPage * entriesToShow,
            limit: entriesToShow,
          },
          {}
        );
        const list = response?.data?.list ?? [];
        setTableData(response?.data?.list ?? []);
        settotalpage(response?.data?.totalCount)

        const allDone = list.every((item) => item.status === "completed");
        if (allDone && intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      } catch (error) { }
    };
    getInclusionExclusionData();
    intervalId = setInterval(getInclusionExclusionData, 30000);
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [entriesToShow, currentPage]);












  const baseStyle = {
    zIndex: "1",
    padding: "25px",
    paddingBottom: "0",
    paddingTop: "10px",
  };

  // Expanded style
  const expandedStyle = {
    marginLeft: expanded ? "240px" : "50px",
    width: `calc(100% - ${expanded ? "240px" : "50px"})`,
  };

  // ProspectCall style (overrides expanded when true)
  const prospectStyle = {
    marginLeft: "0px",
    width: "100%",
  };

  // Final style: decide based on prospectcall
  const appliedStyle = prospectcall
    ? { ...baseStyle, ...prospectStyle }
    : { ...baseStyle, ...expandedStyle };

  return (
    <div className="row" style={appliedStyle}>
      { }
      <MatchFieldsModal
        rootStore={matchAppendStore}
        fileInputRef={fileInputRef}
        fieldOptions={fieldOptions}
        typeOptions={typeOptions}
        uploadFileDetails={uploadFileDetails}
        setUploadFileDetails={setUploadFileDetails}
        handleFileChange={handleFileChange}
        formStatusNegativeAlert={formStatusNegativeAlert}
        setFormStatusNegativeAlert={setFormStatusNegativeAlert}
        handleInClusionExclusionSubMission={handleInClusionExclusionSubMission}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        options={options}
        setOptions={setOptions}
      />
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "0px",
          }}
        >
          <span
            style={{ fontSize: "18px", fontWeight: "500", color: "#252C34" }}
          >
            Inclusion / Exclusion
          </span>
          <div className="tw-flex tw-items-center tw-gap-2">
            {" "}
            <input
              type="text"
              placeholder="Search..."
              className="searchstyle"
              onChange={(e) => setSearch(e.target.value)}
            />
            <Button
              onClick={() => {
                matchAppendStore.setShowMatchModal(true);
                matchAppendStore.setModalStep(parseInt(0));
              }}
              style={{
                color: "white",
                border: "none",
                padding: "8px 10px",
                borderRadius: "4px",
                fontWeight: "500",
                backgroundColor: "#E80070",
                fontSize: "12px",
              }}
              className="custom-login-button "
            >
              <FileUploadOutlinedIcon style={{ fontSize: "16px" }} /> Upload
              List
            </Button>
          </div>
          { }
        </div>
        <HistoryTable
          data={tableData}
          tableType={"Inclusion and Exclusion"}
          inclusionExclusionRowDelete={inclusionExclusionRowDelete}
          onEntriesChange={handleEntriesChange}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          totalpage={totalpage}
        />
      </div>
      {wrongFormattedCSValert && (
        <InfoBar
          Information={fileErrorMessage}
          flag={false}
          popupState={wrongFormattedCSValert}
          setPopupState={setWrongFormattedCSValert}
        />
      )}
      {fileUploadSuccessPopup &&
        showAlertToast({
          type: "Success",
          title: "Success",
          message: "File Uploaded Successfully",
        })}
      {triggerCommonLoader && <CommonLoader />}
    </div>
  );
};
export default InclusionExclusion;
